import React, { useState } from "react";
import { ReactComponent as LeftArrow } from "../../../../assets/appearencePage/arrow-left.svg";
import { ReactComponent as LeftArrowDark } from "../../../../assets/appearencePage/arrow-left-dark.svg";
import { ReactComponent as BrandingIconBw } from "../../../../assets/appearencePage/shield-tick.svg";
import { ReactComponent as BrandingIconBwDark } from "../../../../assets/appearencePage/shield-tick-dark.svg";
import { Link } from "react-router-dom";
import { ReactComponent as TextSvgIcon } from "../../../../assets/appearencePage/text.svg";
import { ReactComponent as InfoIcon } from "../../../../assets/appearencePage/info-circle.svg";
import { ReactComponent as LinkSvgIcon } from "../../../../assets/appearencePage/link.svg";

import * as yup from "yup";

import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";

import { useDispatch, useSelector } from "react-redux";
import { createBrandingSettings } from "../../../../redux/slices/appearance/createBrandingSettingSlice";
import {
  gettingSettingUpdataData,
  getScreenPreviewSetting,
} from "../../../../redux/slices/appearance/appearanceSlice";
import useSettings from "../../../../hooks/useSettings";
import useLocales from "../../../../hooks/useLocales";
import ExtraSmallFilledButton from "../../../../components/common/buttons/ExtraSmallFilledButton";
import AppearanceDeleteButton from "../../../../components/common/buttons/AppearanceDeleteButton";

const Branding = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const { translate } = useLocales();
  const { themeDirection } = useSettings();
  const [subLoading, setSubLoading] = useState(false);

  const schema = yup.object().shape({
    brandingToggle: yup.boolean().required("branding toggle is required"),
    brandingTitle: yup.string(),
    brandingUrl: yup
      .string()
      .test(
        "required",
        translate("cms.branding_url_required"),
        (val) => !!val.trim()
      )
      // .test("http", "Link URL must start with http:// or https://", (value) =>
      //   /^(http|https):\/\//i.test(value)
      // )
      .required(translate("cms.branding_url_required")),
  });

  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),
  });

  const userId = JSON.parse(localStorage.getItem("user"))?.userid;
  const linkId = localStorage?.getItem("linkId");
  const user = {
    userData: userId,
    linkData: linkId,
  };

  const submitHandler = async (data) => {
    const userId = JSON.parse(localStorage.getItem("user"))?.userid;
    const pageName = JSON.parse(localStorage.getItem("user"))?.twofactor
      ?.pageName;
    const linkId = localStorage?.getItem("linkId");

    const formData = {
      brandingStatus: data?.brandingToggle,
      brandingTitle: data?.brandingTitle,
      brandingUrl: data?.brandingUrl,
      userId: userId,
      linkId: linkId,
    };

    setSubLoading(true);

    await dispatch(createBrandingSettings(formData));

    await dispatch(gettingSettingUpdataData(user));
    await dispatch(getScreenPreviewSetting(pageName));
    setSubLoading(false);
  };

  const [deleteStylePending, setDeleteStylePending] = useState(false);

  const deleteHandler = async (data) => {
    const userId = JSON.parse(localStorage.getItem("user"))?.userid;
    const pageName = JSON.parse(localStorage.getItem("user"))?.twofactor
      ?.pageName;
    const linkId = localStorage?.getItem("linkId");
    const formData = {
      brandingStatus: "",
      brandingTitle: "",
      brandingUrl: "",
      userId: userId,
      linkId: linkId,
    };
    setDeleteStylePending(true);

    await dispatch(createBrandingSettings(formData));

    await dispatch(gettingSettingUpdataData(user));
    await dispatch(getScreenPreviewSetting(pageName));
    setDeleteStylePending(false);
  };

  return (
    <div className="px-6">
      <div className="md:hidden mt-10 mb-10 ">
        <Link className="flex items-center gap-3" to={"/dashboard/appearance"}>
          <div className=" flex items-center justify-center">
            {darkMode ? (
              <LeftArrowDark
                className={`h-[20px] w-[20px] ${
                  themeDirection === "rtl" ? "transform -scale-x-100" : ""
                }`}
              />
            ) : (
              <LeftArrow
                className={`h-[20px] w-[20px] ${
                  themeDirection === "rtl" ? "transform -scale-x-100" : ""
                }`}
              />
            )}
          </div>
          <h6 className="w-full text-body_copy2 dark:text-color_v1_dark">
            {/* Branding */}
            {translate("appearance.branding")}
          </h6>
        </Link>
      </div>

      <div
        className={`dark:border-color_dark bg-light_bg_v5 dark:bg-dark-secondary rounded-[10px] px-[25px] py-[30px] mb-10 border border-light_bg_v2`}
      >
        <form onSubmit={handleSubmit((data) => submitHandler(data))}>
          <div className="flex  gap-2 justify-between items-center cursor-pointer">
            <div>
              {darkMode ? (
                <BrandingIconBwDark width={20} height={20} />
              ) : (
                <BrandingIconBw width={20} height={20} />
              )}
            </div>
            <div className="text-small2_b text-heading_color w-full dark:text-color_v1_dark">
              <h1>
                {/* BRANDING */}
                {translate("appearance.branding_cap")}
              </h1>
            </div>

            <label className="relative inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                {...register("brandingToggle")}
                className="sr-only peer"
              />
              <div
                className={`w-[29px] h-[15px] bg-gray-200 dark:bg-[#404040] rounded-full peer peer-checked:after:translate-x-[13.5px] peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-[11px] after:w-[11px] after:transition-all peer-checked:bg-green-600 ${
                  errors?.brandingToggle
                    ? "ring-1 ring-state_color_error bg-red-300 after:bg-state_color_error"
                    : ""
                }`}
              ></div>
            </label>
          </div>
          {errors.brandingToggle && (
            <div className="text-right">
              <small className="text-state_color_error text-small3 ">
                {errors?.brandingToggle?.message}
              </small>
            </div>
          )}

          <div className="mt-[20px]">
            <div className="relative ">
              <input
                type={"text"}
                {...register("brandingTitle")}
                className={`ps-[33px] bg-light_bg_v5 border text-heading_color text-small2 md:text-small1 rounded-md focus:placeholder:text-heading_color focus:outline-none block w-full p-[13px] py-[5px] px-[15px] dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark dark:bg-dark-secondary ${
                  errors?.brandingTitle
                    ? "border-state_color_error"
                    : "border-light_bg_v2 bg-transparent focus:border-font_light_color dark:border-color_dark focus:dark:border-font_color"
                }`}
                placeholder={translate("cms.enter_title")}
              />
              <div className="absolute start-[10px] inset-y-0 flex justify-center items-center cursor-pointer">
                <TextSvgIcon
                  className={`${
                    errors?.brandingTitle
                      ? "stroke-state_color_error"
                      : darkMode
                      ? "stroke-color_v1_dark"
                      : " stroke-heading_color"
                  }`}
                />
              </div>
            </div>
            {errors.brandingTitle && (
              <small className="text-state_color_error text-small3 ">
                {errors?.brandingTitle?.message}
              </small>
            )}
            <div className="flex mt-[6px] gap-[5px] items-center">
              <div className="flex justify-center items-center">
                <InfoIcon />
              </div>
              <div className="text-dark_bg_v5 text-small3 dark:text-dark_bg_v5">
                {/* Leave empty to have the default site branding. */}
                {translate("default_branding")}
              </div>
            </div>

            <div className="relative mt-[20px]">
              <input
                type={"text"}
                {...register("brandingUrl")}
                className={`ps-[33px] bg-light_bg_v5 border text-heading_color text-small2 md:text-small1 rounded-md  focus:outline-none block w-full p-[13px] py-[5px] px-[15px] dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark dark:bg-dark-secondary ${
                  errors?.brandingUrl
                    ? "border-state_color_error placeholder:text-state_color_error"
                    : "border-light_bg_v2 bg-transparent focus:border-font_light_color focus:placeholder:text-heading_color dark:border-color_dark focus:dark:border-font_color"
                }`}
                placeholder={translate("cms.enter_url")}
              />
              <div className="absolute start-[10px] inset-y-0 flex justify-center items-center cursor-pointer">
                <LinkSvgIcon
                  className={`${
                    errors?.brandingUrl
                      ? "stroke-state_color_error"
                      : darkMode
                      ? "stroke-color_v1_dark"
                      : " stroke-heading_color"
                  }`}
                />
              </div>
            </div>
            {errors.brandingUrl && (
              <small className="text-state_color_error text-small3 ">
                {errors?.brandingUrl?.message}
              </small>
            )}

            <div className="flex mt-[25px] cursor-pointer items-center justify-end">
              <AppearanceDeleteButton
                isLoading={deleteStylePending}
                onClickHandler={deleteHandler}
              />
              {/* <button
                type="submit"
                className={`ms-3 rounded-full flex p-1.5 px-[22px] bg-main_color text-white text-small3_b ${
                  subLoading ? "opacity-70" : ""
                } `}
              >
                {subLoading ? (
                  <svg
                    aria-hidden="true"
                    role="status"
                    className="inline w-3 h-3 text-white animate-spin"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="#E5E7EB"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentColor"
                    />
                  </svg>
                ) : (
                  "SAVE"
                )}
                </button> */}
              <ExtraSmallFilledButton
                name={`${translate("biolink_title.save_cap")}`}
                buttonType={"submit"}
                isLoading={subLoading}
                classes={"ms-3"}
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Branding;
